import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core"

const DialogConfiguracoes = ({
    todasMesas,
    classes,
    mesa,
    openConfiguracoes,
    handleCloseConfiguracoes,
    numeroMesa,
    handleChangeNumeroMesa,
    mudarMesa,
}) => {
    return (
        <Dialog open={openConfiguracoes} onClose={handleCloseConfiguracoes} fullWidth>
            <DialogTitle>Configurações</DialogTitle>
            <DialogContent>
                <FormControl style={{ width: "50%" }}>
                    <InputLabel variant="outlined">Mesa</InputLabel>
                    <Select
                        variant="outlined"
                        value={numeroMesa}
                        label="Mesa"
                        onChange={handleChangeNumeroMesa}
                    >
                        {todasMesas.map((_, index) =>
                            index === 0 ? null : (
                                <MenuItem key={index} value={index}>
                                    {index}
                                </MenuItem>
                            )
                        )}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions className={classes.actionsConfiguracoes}>
                <Button onClick={handleCloseConfiguracoes}>Fechar</Button>
                <Button
                    onClick={() => {
                        if (mesa.numeroMesa !== numeroMesa) {
                            mudarMesa(numeroMesa)
                        }
                        handleCloseConfiguracoes()
                    }}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogConfiguracoes
